import api from "./api";

/**
 * Analyze a position using XGID string.
 *
 * XGID format: XGID=<board>:<cube>:<cubeOwner>:<turn>:<dice>:<scoreP>:<scoreO>:<crawford>:<matchLen>:<maxGames>
 *
 * Examples:
 *   Opening 3-1:  "XGID=-b----E-C---eE---c-e----B-:0:0:1:31:0:0:0:0:10"
 *   Cube decision: "XGID=aa--BBBB----dE---d-e----B-:0:0:1:00:0:0:0:0:10"
 *   Take/drop:     "XGID=aa--BBBB----dE---d-e----B-:0:0:1:D:0:0:0:0:10"
 *
 * @param {string} xgid - Full XGID position string
 * @param {number} depth - Analysis depth 0-3 (default 2)
 */
export function analyzePosition(xgid, depth = 2) {
  return api.post("/analyze", { xgid, depth });
}

/**
 * Analyze a position from individual components.
 *
 * @param {object} position
 * @param {string} position.board - Board string (26 chars, XGID format)
 * @param {string} position.dice - Dice roll e.g. "31", "00" for cube, "D" for take/drop
 * @param {number} [position.turn=1] - 1 = player on roll, -1 = opponent
 * @param {number} [position.cube=0] - Cube value (0 = centered at 1)
 * @param {number} [position.cubeOwner=0] - 0=centered, 1=player, -1=opponent
 * @param {number} [position.matchLength=0] - 0 = money game
 * @param {number} [position.scorePlayer=0]
 * @param {number} [position.scoreOpponent=0]
 * @param {number} [position.depth=2]
 */
export function analyzeComponents(position) {
  return api.post("/analyze", position);
}